import { GovFormWeb } from '@gov-design-system-ce/react-form';
import { type UseOverviewForm } from '@gov-nx/module/page';
import { DataBoxSelect, FormCheckbox } from '@gov-nx/ui/web';

type OverviewFormProps = Pick<
	UseOverviewForm,
	'formId' | 'formDefinition' | 'isSentByDatabox' | 'hasDataBoxes' | 'onSubmit'
>;

export const OverviewForm = (props: OverviewFormProps) => (
	<GovFormWeb
		id={props.formId}
		formDefinition={props.formDefinition}
		onSubmit={props.onSubmit}>
		{props.hasDataBoxes ? (
			<>
				<FormCheckbox {...props.formDefinition.fields.sendByDatabox} />
				{props.isSentByDatabox ? (
					<DataBoxSelect {...props.formDefinition.fields.datovaSchrankaId} />
				) : null}
			</>
		) : null}
	</GovFormWeb>
);
